module.exports = __webpack_public_path__ + "img/4__attels_uzlabota.e0d5f7b9.jpg";